// src/Layout.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Layout.css";
import "./App.css";

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="layout-container">
      {/* Header */}
      <header className="custom-header">
        <Link to="/" className="logo-container" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>
          <img src="/logo.webp" alt="Briospark Logo" className="logo-img" />
          <h2 className="logo-text">Briospark</h2>
        </Link>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <div className="dropdown">
            <span className="nav-link-custom1">Products</span>
            <div className="dropdown-menu-custom">
              <Link to="/changer" className="dropdown-item-custom" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>Changer</Link>
              <Link to="/bnpl" className="dropdown-item-custom" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>BNPL</Link>
            </div>
          </div>
          <Link to="/solutions" className="nav-link-custom" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>Solutions</Link>
          <Link to="/aboutus" className="nav-link-custom" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>About Us</Link>
          <Link to="/contactus" className="btn btn-primary custom-contact-btn" onClick={() => { setMenuOpen(false); window.scrollTo(0, 0); }}>Contact us</Link>
        </div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      {children}

      {/* Footer */}
      <footer className="custom-footer">
        <div className="footer-top">
          <Link to="#" className="footer-link">Privacy Policy</Link>
          <Link to="#" className="footer-link">FAQ</Link>
          <Link to="#" className="footer-link">Terms of Service</Link>
        </div>
        <div className="footer-socials">
          <Link to="#"><img src="/twitter.png" alt="Twitter" className="social-icon" /></Link>
          <Link to="#"><img src="/linkedin.png" alt="Linkedin" className="social-icon" /></Link>
        </div>
        <p className="footer-copy">Copyright ©2025 Briospark. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;
